import { isNil } from 'lodash';

export function prepareIdInput(id?: string): string | undefined {
  return isNil(id) ? undefined : id;
}
